import { useState } from "react";

import { clearCrashReports, crashReports, type CrashSession } from "../lib/CrashLog/log";
import { sendingEnabled, sendPendingReports, setSendingEnabled } from "../lib/CrashLog/upload";

function readReports(): CrashSession[] {
  try {
    return crashReports(window.localStorage);
  } catch {
    return [];
  }
}

/** Crashes this device recorded. They stay here until copied. */
export function StatusCrashLog() {
  const [reports, setReports] = useState(readReports);
  const [copied, setCopied] = useState(false);
  const [sending, setSending] = useState(() => {
    try {
      return sendingEnabled(window.localStorage);
    } catch {
      return false;
    }
  });
  const text = JSON.stringify(reports, null, 1);
  const last = reports[0]?.samples.at(-1);
  return (
    <section className="status-deploy" aria-labelledby="status-crash-title">
      <h2 id="status-crash-title" className="status-deploy__title">Crash log</h2>
      <label className="status-detail">
        <input
          type="checkbox"
          checked={sending}
          onChange={(event) => {
            const on = event.target.checked;
            setSending(on);
            setSendingEnabled(window.localStorage, on);
            void sendPendingReports(reports, window.localStorage);
          }}
        />
        {" "}Send this device&apos;s crashes
      </label>
      {reports.length === 0 || last === undefined ? (
        <p className="status-detail">No crashes recorded on this device.</p>
      ) : (
        <>
          <p className="status-detail">
            {reports.length} recorded. Latest: {last.at}s after loading,
            {" "}at {last.scene || last.path}, {last.imageMb} MB of images,
            {" "}{last.domNodes} page elements, {last.fps} fps.
          </p>
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => {
              void navigator.clipboard.writeText(text).then(() => setCopied(true));
            }}
          >
            {copied ? "Copied" : "Copy report"}
          </button>
          {" "}
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => {
              clearCrashReports(window.localStorage);
              setReports([]);
            }}
          >
            Clear
          </button>
          <pre className="status-deploy__json" aria-label="Crash reports">{text}</pre>
        </>
      )}
    </section>
  );
}
